import { Component, OnInit } from '@angular/core';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { interval } from 'rxjs';

@Component({
  selector: 'app-departments',
  templateUrl: './departments.component.html',
  styleUrls: ['./departments.component.scss'],
})
export class DepartmentsComponent implements OnInit {
  childrenDepartments: [];
  pageTitle: string;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  guidanceMsg: string;
  childRows: any[];
  subscription: any;

  constructor(
    private departmentService: DepartmentService,
    private datastoreService: DatastoreService,
    protected alertService: AlertService,
    private router: Router,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    private servicesService: ServicesService,
    private availabilityService: AvailabilityService
  ) {}

  async ngOnInit() {
    this.scrollToTop();
    this.spinner.show();
    // The service is picked before the location, so send the customer back to
    // the start of the journey if they got here without one
    const selectedService = await this.servicesService.getParentService();
    if (!selectedService) {
      this.spinner.hide();
      this.restartJourney();
      return;
    }
    this.getDepartments();
  }

  routerGoBack() {
    this.router.navigate(['/services']);
  }

  restartJourney() {
    this.router.navigate(['/services']);
  }

  async getDepartments() {
    // The parent department and the client config are loaded on the services
    // page, which now comes before this one
    const parentDepartment = this.datastoreService.parentDepartment;
    if (parentDepartment && parentDepartment.extra) {
      this.pageTitle = parentDepartment.extra.location_page_title;
      this.guidanceMsg = parentDepartment.extra.location_page_guidance_text;
    }

    let departments = await this.departmentService.getChildDepartments(
      parentDepartment
    );
    let sortedDepartments = [];
    sortedDepartments = _.orderBy(departments, ['name', 'asc']) as [];
    //filter out departments with variable hide_location_on_user_journey and hide_location_on_user_journey set to Yes
    sortedDepartments = sortedDepartments.filter((dept) => !(dept?.extra?.hide_location_on_user_journey && dept?.extra?.hide_location_on_user_journey === 'Yes'));
    this.spinner.hide();

    //@ts-ignore
    this.childrenDepartments = sortedDepartments;
    this.childRows = [];
    const chunkSize = 3;
    for (let i = 0; i < sortedDepartments.length; i += chunkSize) {
      const chunk = sortedDepartments.slice(i, i + chunkSize);
      this.childRows.push(chunk);
    }
    // while(true){

    // }
    const source = interval(100);
    this.subscription = source.subscribe((val) => {
      let count = 0;
      let all = this.childrenDepartments.length;
      let maxHeight = 0;
      let childRowsMaxHeights = [];
      for (let i = 0; i < this.childRows.length; i++) {
        let row = this.childRows[i];
        childRowsMaxHeights.push(0);
        for (let locations of row) {
          const el = document.getElementById(locations.id);
          if (el) {
            count++;
            if (maxHeight < el.offsetHeight) {
              childRowsMaxHeights[i] = el.offsetHeight;
            }
          }
        }
      }
      if (count >= all) {
        for (let i = 0; i < this.childRows.length; i++) {
          let row = this.childRows[i];
          for (let locations of row) {
            const el = document.getElementById(locations.id);
            el.style.height = `${childRowsMaxHeights[i]}px`;
          }
        }
        this.subscription.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async selectDepartment(location) {
    this.spinner.show();

    // Clear the date and slot if the customer came back and picked another
    // location, as the availability belongs to the location
    const previousLocation = await this.departmentService.getLocation();
    if (previousLocation && previousLocation.id !== location.id) {
      this.datastoreService.selectedDate = null;
      this.datastoreService.selectedSlot = null;
      this.availabilityService.setSelectedSlot(null);
    }

    this.departmentService.set(location);
    this.datastoreService.selectedDepartment = location;
    this.departmentService.setLocation(location);

    // The service was picked on the parent department, so swap it for the
    // matching service on the selected location before moving on
    const parentService = await this.servicesService.getParentService();
    const locationService = await this.servicesService.getServiceForLocation(
      parentService,
      location
    );

    if (!locationService) {
      this.spinner.hide();
      this.alertService.error(
        this.translateService.instant('COMMON.GENERAL_ERR')
      );
      this.scrollToTop();
      return;
    }

    await this.servicesService.set(locationService);
    this.spinner.hide();
    this.router.navigate(['/calendar']);
  }

  // scroll to the top of the page
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
